import React from "react";
import { Alert, Container } from "react-bootstrap";
import { UserTools } from "../../views/admin/UserTools";
import { OrganizationTools } from "../../views/admin/OrganizationTools";
import { ProtectedComponent } from "../../../auth/ProtectedComponent";
import { PlatformConfigTools } from "../../views/admin/PlatformConfigTools";
import { AnalyticsLibraryEventTools } from "../../views/admin/AnalyticsLibraryEventTools";
import { CreateProjectConfigTools } from "../../views/admin/CreateProjectConfigTools";
import styles from "./AdminPage.module.scss";

const AdminPageImplementation = () => {
    return (
        <Container className={`${styles.responsiveContainer} text-center mt-5`}>
            <Alert variant="danger">
                <h5>Admin tools ahead!</h5>
                <div className="d-flex justify-content-center text-start">
                    <ul>
                        <li>
                            Changes made here are instant and permanent <br />
                            <small>(Unless there is a save button)</small>
                        </li>
                        <li>
                            UI is janky in places and does not update in
                            realtime
                        </li>
                    </ul>
                </div>
            </Alert>
            <ProtectedComponent scopes={["admin"]}>
                <OrganizationTools />
            </ProtectedComponent>
            <UserTools />
            <AnalyticsLibraryEventTools />
            <ProtectedComponent scopes={["admin"]}>
                <PlatformConfigTools />
            </ProtectedComponent>
            <ProtectedComponent scopes={["admin"]}>
                <CreateProjectConfigTools />
            </ProtectedComponent>
        </Container>
    );
};

export const AdminPage = React.memo(AdminPageImplementation);
